import { createSelector } from "@reduxjs/toolkit";
import { getProducts } from "../../selectors";

const emptyArray = [];

const getSponsoredProducts = createSelector([getProducts], (products) => {
  if (!products?.length) {
    return emptyArray;
  }

  return products.filter((product) => product.isSponsored);
});

export const getSponsoredProductCount = createSelector(
  [getSponsoredProducts],
  (sponsoredProducts) => sponsoredProducts.length,
);

export default getSponsoredProducts;
